import { FormControl, InputLabel, Select, MenuItem, CircularProgress, Box } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { ServiceObject } from '../../../../../../@types/service.type';
import { NodeAttributeType, FaultCategory } from '../../../../../../configs/enums';
import { useGetFilteredNodeAttributesByCustomRange } from '../../../../../../queries/structure-query';

interface FaultOption {
  label: string;
  value: string;
}

interface MobileFaultSelectionFieldProps {
  service: ServiceObject;
  value: string;
  onChange: (value: string) => void;
  isRequired: boolean;
}

export const MobileFaultSelectionField: React.FC<MobileFaultSelectionFieldProps> = ({
  service,
  value,
  onChange,
  isRequired,
}) => {
  const [options, setOptions] = useState<FaultOption[]>([]);

  const nodeAttributesQuery = useGetFilteredNodeAttributesByCustomRange(
    `${service?.contractId || service?.clientId}`,
    [NodeAttributeType.FaultCategory, NodeAttributeType.FaultCode],
    service.serviceTypeCode,
    FaultCategory.Observed,
    service.actionTypeCode
  );

  useEffect(() => {
    if (service.mainLocationNodeId && service.serviceTypeCode) {
      nodeAttributesQuery.refetch();
    }
  }, [service.mainLocationNodeId, service.serviceTypeCode]);

  useEffect(() => {
    if (nodeAttributesQuery.data) {
      const faultAttributes = nodeAttributesQuery.data.filter(
        (obj: any) => obj.propertyTypeCode === NodeAttributeType.FaultCode
      );
      const faults: FaultOption[] = faultAttributes.map((obj: any) => ({
        label: obj?.value?.name || '_',
        value: JSON.stringify({
          id: obj.id,
          name: obj.value?.name,
          customerId: obj.value?.customerId,
          customerId2: obj.value?.customerId2,
          categoryId: obj.value?.categoryId,
        }),
      }));
      setOptions(faults);
    }
  }, [nodeAttributesQuery.data]);

  if (nodeAttributesQuery.isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 1 }}>
        <CircularProgress size={20} />
      </Box>
    );
  }

  return (
    <FormControl fullWidth size="small">
      <InputLabel>Fault Selection{isRequired ? ' *' : ''}</InputLabel>
      <Select
        value={value || ''}
        label={`Fault Selection${isRequired ? ' *' : ''}`}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((opt, index) => (
          <MenuItem key={index} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
